import { render, staticRenderFns } from "./ModificarActivoSaux.vue?vue&type=template&id=db8b3164"
import script from "./ModificarActivoSaux.vue?vue&type=script&lang=js"
export * from "./ModificarActivoSaux.vue?vue&type=script&lang=js"
import style0 from "./ModificarActivoSaux.vue?vue&type=style&index=0&id=db8b3164&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports